import { Carousel, Slide } from 'vue-carousel';
import accordion from './accordion.vue';
import ageCheck from './age-check.vue';
import qtyInput from './qty.vue';
import intro from './intro.vue';

export default {
    accordion,
    ageCheck,
    qtyInput,
    intro,
    Carousel,
    Slide,
};
